import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-semantic-neutral',
  templateUrl: './disable-semantic-neutral.component.html',
  styleUrls: ['./disable-semantic-neutral.component.css'],
})
export class DisableSemanticNeutralComponent {
  @Input() question!: Question;
}
